<template>
  <span class="top-bar-action" @click="$emit('click')">
    <v-icon size="18" color="#0c315e">{{icon}}</v-icon>  
  </span>
</template>

<script>

export default {
  name: 'TopBarAction',
  props: ['icon']
}
</script>

<style lang="scss" scoped>
.top-bar-action {
  background-color: #ffffff;
  border: 1px solid #eaedf2;
  width: 36px;
  height: 30px;

  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>